<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="true"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="_date"
        :label="label"
        :prepend-icon="showIcon ? 'mdi-calendar' : ''"
        readonly
        v-bind="attrs"
        v-on="on"
        outlined
        dense
        hide-details="auto"
      ></v-text-field>
    </template>
    <v-date-picker v-model="_date" no-title scrollable> </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: 'DatePicker',
  props: {
    date: { type: String },
    label: { type: String },
    showIcon: { type: Boolean, default: true },
  },
  data() {
    return {
      menu: false,
    }
  },
  computed: {
    _date: {
      get() {
        return this.date
      },
      set(date) {
        this.$emit('change', date)
      },
    },
  },
}
</script>

<style lang="scss" scoped></style>
